<template>
    <section
      class="flex flex-col items-center justify-center bg-secondary font-semibold text-white"
      id="contact"
    >
      <h2 class="mx-10 mt-16 text-center text-[32px] font-bold uppercase">
        Neváhejte mě kontaktovat
      </h2>
      <div
        class="mx-10 mt-16 flex w-5/6 flex-col items-center justify-center gap-10 text-xl sm:text-1.5xl lg:flex-row"
      >
        <div
          class="flex w-full flex-col items-center justify-center gap-3 rounded-[40px] rounded-br-none bg-[#5BD3AF] p-12 sm:flex-row md:min-w-[450px] md:max-w-[450px]"
          data-aos="fade-right"
          data-aos-delay="500"

        >
          <i class="pi pi-phone mr-2 animate-shake" style="font-size: 2rem"></i
          ><a href="tel:+420724219238">+420 724 219 238</a>
        </div>
        <div
          class="flex w-full flex-col items-center justify-center gap-3 rounded-[40px] rounded-bl-none bg-[#5BD3AF] p-12 sm:flex-row md:min-w-[450px] md:max-w-[450px]"
          data-aos="fade-left"
          data-aos-delay="500"
        >
          <i class="pi pi-envelope mr-2" style="font-size: 2rem"></i>
          <a href="mailto:magdalenabrydl@gmail.com">magdalenabrydl@gmail.com</a>
        </div>
      </div>
      <div
        class="mx-10 my-20 flex flex-col items-center justify-center gap-4 text-center text-xl sm:flex-row sm:text-left sm:text-2xl"
        data-aos="fade"
        data-aos-delay="1000"
      >
        <img src="@/assets/contact-logo.svg" alt="Contact Logo" class="mr-2" />
        <a
          href="https://www.google.com/maps/place/Lan%C5%A1krounsk%C3%A1+381%2F5,+568+02+Svitavy+2-P%C5%99edm%C4%9Bst%C3%AD/@49.7584267,16.4713258,17z/data=!3m1!4b1!4m6!3m5!1s0x470d8bd2423c8825:0xb7016a10c101e539!8m2!3d49.7584267!4d16.4713258!16s%2Fg%2F11c2cypvhg?entry=ttu&g_ep=EgoyMDI0MTIwMS4xIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          class="text-balance"
          >Lanškrounská 5, Svitavy, 568 02</a
        >
      </div>
    </section>

    <footer class="bg-[#51A48B] px-12 py-4 text-white">
      <div class="flex flex-col items-center md:flex-row md:justify-between">
        <div class="md:flex-1"></div>
        <div class="flex items-center gap-1 opacity-65">
          <p class="text-[12px]">powered by</p>
          <a href="https://dominikmedal.cz/" target="_blank"
            ><img src="@/assets/dm.svg" alt="Dominik Medal"
          /></a>
        </div>
        <div class="text-right md:flex-1 opacity-65">
          <p class="text-[12px]">© 2024 Magdaléna Brýdlová</p>
        </div>
      </div>
    </footer>
</template>

<script setup>
</script>

<style scoped></style>
